module.exports = __webpack_public_path__ + "./fonts/MarvelousScriptDemo-7lGV.otf";